import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

export function QrCode({ value, size }: { value: string; size: number }) {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    QRCode.toString(value, { type: 'svg', margin: 0, errorCorrectionLevel: 'M' }).then((s) => live && setSvg(s));
    return () => {
      live = false;
    };
  }, [value]);
  return (
    <span
      role="img"
      aria-label={`QR code ${value}`}
      style={{ display: 'inline-block', width: size, height: size, lineHeight: 0 }}
      dangerouslySetInnerHTML={svg ? { __html: svg.replace('<svg ', `<svg width="${size}" height="${size}" `) } : undefined}
    />
  );
}
